import { createFileRoute } from '@tanstack/react-router'
import WorkflowEditorContainer from '@/components/workflow-editor'

export const Route = createFileRoute('/_auth/automation/editor/')({
  component: WorkflowEditorContainer,
})
